import _extends from "@babel/runtime/helpers/extends";
import * as React from "react";
import { forwardRef } from "react";
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M12 18.9a6.9 6.9 0 1 0 0-13.8 6.9 6.9 0 0 0 0 13.8m0 1.4a8.3 8.3 0 1 0 0-16.6 8.3 8.3 0 0 0 0 16.6",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M10.25 10.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0m5.5 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M15.24 12.842a.7.7 0 0 1 .418.897c-.615 1.69-2.155 2.52-3.646 2.544-1.485.025-3.04-.747-3.665-2.364a.7.7 0 0 1 1.306-.505c.374.967 1.32 1.486 2.335 1.47 1.009-.017 1.969-.564 2.354-1.623a.7.7 0 0 1 .897-.419",
  clipRule: "evenodd"
}));
const ForwardRef = /*#__PURE__*/forwardRef(SvgComponent);
export default ForwardRef;
//# sourceMappingURL=SmileyFaceIcon24.js.map